import { XMarkIcon } from "@heroicons/react/24/outline";
import { Button } from "@heroui/react";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import BasicInfoSection from "../../component/profile/edit/basicInfo";
import { UpdateProfileUIProps } from "../../types/updateProfileProps";

const UpdateProfileUI: React.FC<UpdateProfileUIProps> = (props) => {
    const {
        error,
        isSubmitting,
        handleSubmit,
        onClose,
    } = props;

    const { t, i18n } = useTranslation("updateProfile");

    useEffect(() => {
        const savedLanguage = localStorage.getItem("i18nextLng") || "en";
        if (i18n.language !== savedLanguage) {
            i18n.changeLanguage(savedLanguage);
        }
    }, [i18n]);

    return (
        <div className="absolute inset-0 bg-white border border-gray-300 z-20 p-6 overflow-hidden flex flex-row gap-8 scrollbarWidth-none">
            <form
                onSubmit={handleSubmit}
                className="flex-1 overflow-y-auto pr-4 max-h-full space-y-6 text-base text-gray-800"
            >
                <h3 className="text-2xl font-semibold mb-4">{t("editProfile")}</h3>
                {error && <p className="text-red-600 text-sm">{error}</p>}

                <BasicInfoSection {...props} />
            </form>
            <div className="w-56 shrink-0 flex flex-col gap-4">
                <div className="sticky top-0 bg-white p-3 flex flex-col gap-2 rounded-xl shadow-sm">
                    <Button
                        type="submit"
                        variant="solid"
                        size="md"
                        className="bg-blue-600 text-white w-auto px-6"
                        onClick={handleSubmit}
                        isDisabled={isSubmitting}
                        isLoading={isSubmitting}
                    >
                        {isSubmitting ? t("saving") : t("saveChanges")}
                    </Button>
                    <Button
                        size="md"
                        variant="flat"
                        className="text-red-600 hover:bg-red-100 w-auto px-6"
                        onClick={onClose}
                    >
                        <XMarkIcon className="w-4 h-4 mr-1" /> {t("close")}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default UpdateProfileUI;
